import React from 'react';
import { useBrokerDetailsStore } from '../../state/brokerDetailsStore';
import { BrokerStatusType, PermissionType } from '@apply/constants';
import { hasPermission } from '@apply/ui';
import { Button, ButtonTheme } from '@apply/components';

interface ActionButtonsSectionProps {
    onSave: () => void;
    onActivate: () => void;
    onReject: () => void;
    onCancel: () => void;
}

export const ActionButtonsSection: React.FC<ActionButtonsSectionProps> = ({ onSave, onActivate, onReject, onCancel }) => {
    const brokerStatus = useBrokerDetailsStore((s) => s.brokerStatus);
    const eSignAgreement = useBrokerDetailsStore((s) => s.eSignAgreement);
    const isAdmin = useBrokerDetailsStore((s) => s.isAdmin);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);

    const closeButton = isAdmin ? (
        <Button
            id='cancelButton'
            theme={ButtonTheme.LinkBlue}
            handleClick={onCancel}
            hint='Cancel and changes and close dialog'
            width='250px'
        >
            Cancel
        </Button>
    ) : null;

    if (isAdmin && (brokerStatus === BrokerStatusType.InviteAccepted || brokerStatus === BrokerStatusType.Rejected)) {
        return (
            <>
                <div className='actionButtonsRight'>
                    {closeButton}
                    <Button
                        id='activateButton'
                        theme={ButtonTheme.Primary}
                        handleClick={onActivate}
                        disabled={!hasPermission(PermissionType.BrokerApproveReject)}
                    >
                        {brokerStatus === BrokerStatusType.Rejected ? 'Re-Activate' : 'Activate'}
                    </Button>
                    {brokerStatus === BrokerStatusType.InviteAccepted && (
                        <Button
                            id='rejectButton'
                            theme={ButtonTheme.Decline}
                            handleClick={onReject}
                            disabled={!hasPermission(PermissionType.BrokerApproveReject)}
                        >
                            Reject
                        </Button>
                    )}
                </div>
            </>
        );
    }

    return (
        <>
            <div className='actionButtonsRight'>
                {closeButton}
                <Button
                    id='saveButton'
                    theme={ButtonTheme.Primary}
                    disabled={isBroker && !eSignAgreement}
                    handleClick={onSave}
                    width='300px'
                >
                    Save Account
                </Button>
            </div>
        </>
    );
};
